import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'apps/portal/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvestmentReportContainerService {

  private months: any;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    this.months = [
      { month: 1, description: 'Janeiro' },
      { month: 2, description: 'Fevereiro' },
      { month: 3, description: 'Março' },
      { month: 4, description: 'Abril' },
      { month: 5, description: 'Maio' },
      { month: 6, description: 'Junho' },
      { month: 7, description: 'Julho' },
      { month: 8, description: 'Agosto' },
      { month: 9, description: 'Setembro' },
      { month: 10, description: 'Outubro' },
      { month: 11, description: 'Novembro' },
      { month: 12, description: 'Dezembro' }
    ]
  }

  private getStandardHeaders() {​​​​​​​
    return {​​​​​​​
      headers: new HttpHeaders({​​​​​​​
        'Content-Type': 'application/json;charset=utf-8',
        'Ocp-Apim-Subscription-Key': environment.investmentReport.OcpApimSubscriptionKey
      }​​​​​​​)
    }​​​​​​​;
  }​​​​​​​

  getIRCompany() {​​​​​​​
    const url = environment.investmentReport.endPointAPI + environment.investmentReport.getCompany;
    return this.http.get(url, this.getStandardHeaders())
    .pipe(
      catchError((error) => {​​​​​​​
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      }​​​​​​​)
    )
  }​​​​​​​

  getIRPeriod(company: string) {​​​​​​​
    const url = environment.investmentReport.endPointAPI + environment.investmentReport.getPeriod;
    return this.http.get(`${url}?company=${company}`, this.getStandardHeaders())
    .pipe(
      catchError((error) => {​​​​​​​
        console.log(error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      }​​​​​​​)
    )
  }​​​​​​​

  getIRInvestmentReportList(company: string, year: string, month: string) {​​​​​​​
    const url = environment.investmentReport.endPointAPI + environment.investmentReport.getInvestmentReportList;
    return this.http.get(`${url}?company=${company}&year=${year}&month=${month}`, this.getStandardHeaders())
    .pipe(
      catchError((error) => {​​​​​​​
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      }​​​​​​​)
    )
  }​​​​​​​

  getIRDocInvestmentReport(company: string, year: string, month: string, fileName: string) {​​​​​​​
    
    const httpOptions = {​​​​​​​
      responseType: 'blob' as 'json',
      headers: new HttpHeaders ({​​​​​​​
        'Ocp-Apim-Subscription-Key': environment.investmentReport.OcpApimSubscriptionKey,
        Accept: 'application/pdf'
      }​​​​​​​)
    }​​​​​​​;
    
    const url = environment.investmentReport.endPointAPI + environment.investmentReport.getDocInvestmentReport;
    return this.http.get(`${url}?company=${company}&year=${year}&month=${month}&file=${fileName}`, httpOptions)
    .pipe(
      catchError((error) => {​​​​​​​
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      }​​​​​​​)
    )
  }​​​​​​​

  getFileName(info: any): string {
    return info.name;
  }

  public getMonthDes(numberMonth: String): string {
    const pos = this.months.findIndex(obj => obj.month == numberMonth);
    return this.months[pos].description;
  }

}​​​​​​​

